export default {
  name: 'Latest news Infinite',
  htmlId: 'latestNewsInfinite',
};
